import React, { useEffect, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import Helpers from '@Apis/helpers';
import { Tabs } from 'antd';
import SyncData from './Steps/SyncData';
import InstallBusy from './Steps/BusyInstall';
import BusyMapLocations from './Steps/BusyMapLocations';
import BusyMapUOM from './Steps/BusyMapUOM';
import BusySuccess from './Steps/BusySuccess';
import BusyIntegrationActions from '../../../../../actions/integrations/busyIntegrationAction';
import BusyMapTaxes from './Steps/BusyMapTaxes';
import BusyConfig from './Steps/BusyConfig';
import BusyTabLoading from './BusyTabLoading';

const busyIntegrationTabs = [{
  component: InstallBusy,
  stepName: 'Install Busy',
}, {
  component: BusyConfig,
  stepName: 'Configuration',
}, {
  component: BusyMapLocations,
  stepName: 'Map Locations',
}, {
  component: BusyMapUOM,
  stepName: 'Setup Import/ Export UOM',
}, {
  component: BusyMapTaxes,
  stepName: 'Map Purchase Taxes',
}, {
  component: SyncData,
  stepName: 'Sync Data',
}, {
  component: BusySuccess,
  stepName: 'Review & Save',
}].map((i, _idx) => {
  i.stepNumber = (_idx + 1).toString();
  return i;
});

const BusySetup = ({
  user, getBusyConnectionsLoading, getTenantsLoading,
  getBusyConnections, history, busyConnections,
}) => {
  const createStep = '1';
  const [step, setStepState] = useState('');
  const [integrationBusyId, setIntegrationBusyId] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedBusyConnection, setSelectedBusyConnection] = useState('');
  const [isCreateFlow, setIsCreateFlow] = useState('');

  function setStep(_step, _integrationBusyId, isCreateFlowURL) {
    // eslint-disable-next-line no-param-reassign
    _integrationBusyId = _integrationBusyId || integrationBusyId;
    setStepState(_step.toString());
    setIsCreateFlow(isCreateFlowURL);
    history.push(`/admin/integration/busy/setup?${_integrationBusyId ? `integration_busy_id=${_integrationBusyId}` : ''}&step=${_step}${isCreateFlowURL ? `&is_create_flow=${isCreateFlowURL}` : ''}`);
  }

  useEffect(() => {
    setSelectedBusyConnection((busyConnections || [])?.find((i) => i.integration_busy_id == integrationBusyId));
  }, [busyConnections, integrationBusyId]);

  useEffect(() => {
    const isCreateFlowURL = Helpers.getValueFromUrl('is_create_flow');
    const urlStepNumber = Helpers.getValueFromUrl('step');
    if (isCreateFlowURL && urlStepNumber !== createStep) {
      setStep(createStep, null, true);
    } else if (isCreateFlowURL && urlStepNumber) {
      setIsCreateFlow(isCreateFlowURL);
      setStepState(urlStepNumber);
    } else {
      setLoading(getBusyConnectionsLoading || getTenantsLoading);
      getBusyConnections(user?.tenant_info?.org_id, (connections) => {
        const integrationBusyIdURL = Number(Helpers.getValueFromUrl('integration_busy_id'));
        setIntegrationBusyId(integrationBusyIdURL);
        const busyConnection = connections?.find((connection) => connection?.integration_busy_id === integrationBusyIdURL);
        setSelectedBusyConnection(busyConnection);
        if (busyConnection && urlStepNumber) {
          setStep(urlStepNumber, integrationBusyIdURL);
        } else if (busyConnection && ['CONNECTED', 'READY'].includes(busyConnection?.status)) {
          setStep('2', integrationBusyIdURL);
        } else if (isCreateFlowURL) {
          history.push('/admin/integration/busy/setup?step=1&is_create_flow=true');
        } else {
          history.push('/admin/integration/busy');
        }
      });
    }

    setLoading(false);
  }, []);
  // const selectedTab = busyIntegrationTabs.find((i) => i.stepNumber === step);
  return (
    <Fragment>
      <div className="busy-integration-wrapper">
        {!step ? <BusyTabLoading /> : (
          <Tabs
            activeKey={step}
            items={busyIntegrationTabs.map((j) => ({
              key: j.stepNumber,
              label: j.stepName,
              children: loading ? <BusyTabLoading /> : <j.component setStep={(_s) => setStep(_s)} stepNumber={j.stepNumber} integrationBusyId={integrationBusyId} busyConnection={selectedBusyConnection} isCreateFlow={isCreateFlow} />,
              disabled: (isCreateFlow && j.stepNumber !== createStep),
            }))}
            onChange={(activeKey) => setStep(activeKey)}
          />
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, BusyIntegrationReducers }) => ({
  user: UserReducers.user,
  getBusyConnectionsLoading: BusyIntegrationReducers.getBusyConnectionsLoading,
  busyConnections: BusyIntegrationReducers.busyConnections,
});

const mapDispatchToProps = (dispatch) => ({
  getBusyConnections: (orgId, callback) => dispatch(BusyIntegrationActions.getBusyConnections(orgId, callback)),
});

BusySetup.propTypes = {
  user: PropTypes.any,
  history: PropTypes.any,
  getBusyConnectionsLoading: PropTypes.bool,
  getTenantsLoading: PropTypes.bool,
  getBusyConnections: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusySetup));
